import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import LandingPage from '../views/Landing Page/LandingPage';
import ProjectListPage from '../views/Projects List Page/ProjectListPage';
import ProjectDetailPage from '../views/Project Detail Page/ProjectDetailPage';
import ContactUsPage from '../views/Contact Us Page/ContactUsPage';
import PageTransition from "./PageTransition";

const AnimatedRoutes = () => {
    const location = useLocation();

    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={
                    <PageTransition>
                        <LandingPage />
                    </PageTransition>
                } />
                <Route path="/work" element={
                    <PageTransition>
                        <ProjectListPage />
                    </PageTransition>
                } />
                <Route path="/work/:id" element={
                    <PageTransition>
                        <ProjectDetailPage />
                    </PageTransition>
                } />
                <Route path="/contact-us" element={
                    <PageTransition>
                        <ContactUsPage />
                    </PageTransition>
                } />
            </Routes>
        </AnimatePresence>
    );
};

export default AnimatedRoutes;
